import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToastService {
  readonly message = signal<string | null>(null);
  readonly tone = signal<'good' | 'bad'>('good');
  private timer = 0;

  show(message: string, tone: 'good' | 'bad' = 'good'): void {
    this.message.set(message);
    this.tone.set(tone);
    window.clearTimeout(this.timer);
    this.timer = window.setTimeout(() => this.message.set(null), 3600);
  }

  dismiss(): void {
    this.message.set(null);
  }
}
